import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";
import firebase from 'firebase';
import { servicios } from './../properties';
const mapState = (state) => {
	return {};
};

const mapDispatch = (dispatch) => {
	return {
		resetPaso: () => {
			dispatch({ "type": "RECUPERAR_RESET_PASO" });
		}
	};
};

class LigaExpiro extends React.Component {
	state = {
		titulo: "",
		mensaje: "",
		mensaje2: ""
	}

	componentDidMount = () => {
		if (localStorage.getItem("ligaUtilizada") && localStorage.getItem("ligaUtilizada") === "si") {
			this.setState({ titulo: "Liga ya utilizada" });
			this.setState({ mensaje: "Esta liga ya fue utilizada anteriormente." });
			this.setState({ mensaje2: "Por favor inténtelo con una nueva." });
		} else {
			this.setState({ titulo: "Liga no válida" });
			this.setState({ mensaje: "La liga solo está disponible por 15 minutos." });
			this.setState({ mensaje2: "Favor de generar otra." });
		}
	}

	back = () => {
		localStorage.removeItem("ligaUtilizada");
		this.props.resetPaso();
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			var data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})

	}

	render() {
		return <div>
			<div className="login-form">
				<div className="h1-titulo text-center">{this.state.titulo}</div>
				<div className="text-center mt-70">
					<div className="mt-25">
						<p>{this.state.mensaje}</p>
						<p>{this.state.mensaje2}</p>
					</div>
				</div>
			</div>
			<div className="text-center mt-70">
				<button onClick={this.back} className="orange-rectangle">Aceptar</button>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(LigaExpiro);


// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/ligaExpiro.cmpt.js